export default __webpack_public_path__ + "static/media/roulette.efd83630.webp";